<style lang="less">
.my-echart {
	width: 100%;
}
</style>
<template>
	<div class="echart-wrap">
		<div class="my-echart" />
	</div>
</template>
<script>
// 引入 ECharts 主模块
var echarts = require('echarts/lib/echarts');
// 引入柱状图
require('echarts/lib/chart/bar');
//引入饼状图
require('echarts/lib/chart/pie');
// 引入提示框和标题组件
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title');

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			echart: null
		};
	},
	watch: {
		data(v) {
			this.echart.setOption(v, false);
		}
	},
	mounted() {
		const dom = this.$el.querySelector('.my-echart');
		this.echart = echarts.init(dom);
		if (this.data) {
			this.echart.setOption(this.data, false);
		}
	}
};
</script>
